import { connect } from 'react-redux'
import ContactListFormView from './ContactListFormView.jsx'

import { fetchContactList, addContactToContactList, removeContactFromContactList, createContactList, updateContactList } 
from 'src/legacy/redux/actions/contactList.jsx';

import { invalidateContacts, fetchContacts } from 'src/legacy/redux/actions/rolodex.jsx';
import { selectContact, deselectContact, invalidateContactSelection } from 'src/legacy/redux/actions/selection.jsx';
import { fetchReportSummary } from 'src/legacy/redux/actions/home.jsx';
import withUseHooks from 'src/legacy/components/withUseHooks.jsx';

const mapStateToProps = (state, ownProps) => {
  var id = ownProps.id;
  console.log(id);
  
  var contactList = state.legacyRootReducer.contactLists.contactList[id];
  console.log(contactList);
  

  return {
    globalContactsEnabled: state.accounts.item.globalContactEnabled,
    contactList: contactList && contactList.item ? contactList.item : null,
    updating: contactList && contactList.updating ? contactList.updating : false,
    creating: state.legacyRootReducer.contactLists.creating,
    currentPage: state.legacyRootReducer.rolodex.pagination.current,
    totalPages: state.legacyRootReducer.rolodex.pagination.totalPages,
    contacts: state.legacyRootReducer.rolodex.items,
    loading: state.legacyRootReducer.rolodex.loading,
    selectedContacts: state.legacyRootReducer.selection.contacts
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    fetchContactList: (id) => {
      return dispatch(fetchContactList(id));
    },

    createContactList: (contact) => {
      return dispatch(createContactList(contact));
    },

    updateContactList: (id, contact) => {
      return dispatch(updateContactList(id, contact));
    },

    addContactToContactList: (contactListId, contactId) => {
      return dispatch(addContactToContactList(contactListId, contactId));
    },

    removeContactFromContactList: (contactListId, contact) => {
      return dispatch(removeContactFromContactList(contactListId, contact))
    },

    selectContact: (contact) => {
      return dispatch(selectContact(contact));
    },

    deselectContact: (item) => {
      return dispatch(deselectContact(item));
    },

    invalidateContactSelection: () => {
      return dispatch(invalidateContactSelection());
    },

    fetchContacts: (filter, page, query) => {
      return dispatch(fetchContacts(filter, page, query));
    },

    invalidateContacts: () => {
      return dispatch(invalidateContacts());
    },

    fetchReportSummary: () => {
      return dispatch(fetchReportSummary());
    }
  }
}

const mergeProps = (stateProps, dispatchProps, ownProps) => {
  return Object.assign({}, ownProps, {
    ...stateProps,
    ...dispatchProps,
    isContactSelected: (contact) => {
      var contacts = [];
      if (stateProps && stateProps.contactList) {
        contacts = stateProps.contactList.contacts;
      } else {
        contacts = stateProps.selectedContacts;
      }

      if (!contacts || contacts.length == 0) {
        return false;
      }

      let index = contacts.findIndex((item) => {
        return item.id == contact.id;
      })

      return index != -1;
    },
    isContactDisabled: (contact) => {
      var contacts = [];
      if (stateProps && stateProps.contactList) {
        contacts = stateProps.contactList.contacts;
      } 

      if (!contacts || contacts.length == 0) {
        return false;
      }

      let index = contacts.findIndex((item) => {
        return item.id == contact.id && item.persisted;
      })

      return index != -1;
    }
  })
}

const ContactListFormContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps
)(ContactListFormView)

export default withUseHooks(ContactListFormContainer);